import { HeartHandshake, ArrowUpRight } from "lucide-react";
import PageHeader from "../components/PageHeader";
import { Reveal } from "../components/Reveal";
import { IMAGES, TITHELY_URL } from "../data/content";

const FUNDS = [
  { name: "Tithe", desc: "Honor God with the firstfruits of your increase." },
  { name: "Offering", desc: "Sow a freewill seed into the work of the Kingdom." },
  { name: "Building Fund", desc: "Help us build for generations to come." },
  { name: "Summit Registration", desc: "Secure your place at PeakDwellers 2026." },
  { name: "ALU Tuition", desc: "Invest in apostolic training and formation." },
];

const openTithely = () => window.open(TITHELY_URL, "_blank", "noopener,noreferrer");

export default function Give() {
  return (
    <div data-testid="give-page">
      <PageHeader overline="Sow Into The Kingdom" lines={["Give"]}
        sub="Your seed advances prophetic ministry, apostolic training, and Kingdom harvest." image={IMAGES.worship1} />

      <section className="px-6 md:px-10 max-w-[1600px] mx-auto pb-32 grid grid-cols-1 md:grid-cols-12 gap-12">
        <Reveal className="md:col-span-5">
          <HeartHandshake className="text-secondary mb-6" size={32} />
          <h2 className="font-editorial text-4xl md:text-5xl text-foreground leading-tight">
            “Bring the whole tithe into the storehouse.”
          </h2>
          <p className="font-body text-muted-foreground mt-8 leading-relaxed max-w-md">
            Give your tithes, offerings, and gifts securely through Tithely. You can choose your fund and amount on the giving page.
          </p>
          <button onClick={openTithely} data-testid="give-submit"
            className="group inline-flex items-center gap-3 mt-10 bg-primary text-primary-foreground overline px-8 py-5 hover:bg-primary/85 transition-colors duration-300">
            Give Securely with Tithely
            <ArrowUpRight size={18} className="group-hover:rotate-45 transition-transform duration-300" />
          </button>
        </Reveal>

        <Reveal delay={0.15} className="md:col-span-7">
          <p className="overline text-primary mb-6">Where Your Gift Goes</p>
          <div className="border-t border-border">
            {FUNDS.map((f) => (
              <button key={f.name} onClick={openTithely} data-testid={`fund-${f.name}`}
                className="group w-full flex items-center justify-between text-left py-6 border-b border-border hover:px-4 transition-all duration-300 hover:bg-muted/30">
                <div>
                  <span className="font-display uppercase text-xl md:text-2xl text-foreground group-hover:text-secondary transition-colors duration-300">
                    {f.name}
                  </span>
                  <span className="block font-body text-sm text-muted-foreground mt-1">{f.desc}</span>
                </div>
                <ArrowUpRight size={20} className="text-muted-foreground group-hover:text-primary shrink-0 transition-colors" />
              </button>
            ))}
          </div>
          <p className="overline text-muted-foreground text-[0.6rem] mt-6">
            Secure giving powered by Tithely
          </p>
        </Reveal>
      </section>
    </div>
  );
}

